"use client";

import React, { useState, useEffect } from "react";
import { FaChevronDown } from "react-icons/fa";
import "./contact.css";

const faqData = [
  {
    question: "What services does your company offer?",
    answer:
      "We offer a wide range of IT services, including website development, mobile app development, digital marketing, software development, staff augmentation, and UI/UX design.",
  },
  {
    question: "Do you work with startups as well as established enterprises?",
    answer:
      "Yes, we cater to both startups and established businesses. Our flexible service models are designed to meet the specific needs of clients, regardless of their size.",
  },
  {
    question: "Can you handle international projects?",
    answer:
      "Yes, we have experience working with clients globally, and we ensure seamless communication and project management across different time zones.",
  },
  {
    question: "What platforms do you use for website development?",
    answer:
      "We develop websites using modern platforms and frameworks such as Laravel, CodeIgniter, Shopify, WordPress, and the MERN stack (MongoDB, Express.js, React, Node.js).",
  },
  {
    question: "Will the website be optimized for search engines (SEO)?",
    answer:
      "Yes, we ensure SEO optimization with proper meta tags, fast loading speeds, mobile responsiveness, and schema markup to improve search engine rankings.",
  },
  {
    question: "Do you develop apps for both Android and iOS?",
    answer:
      "Yes, we develop native apps for both Android and iOS, as well as cross-platform apps using Flutter and React Native for faster development and lower costs.",
  },
  {
    question: "How do you measure the success of digital marketing campaigns?",
    answer:
      "We use key performance indicators (KPIs) such as website traffic, conversion rates, click-through rates (CTR), and return on investment (ROI) to measure the success of our campaigns.",
  },
];

const ContactClient = ({ initialHomeData }) => {
  const [homeData, setHomeData] = useState(initialHomeData || null);
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    if (initialHomeData) return;
    const fetchHomeData = async () => {
      try {
        const res = await fetch("/api/home/all?isActive=true");
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        const contentType = res.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          throw new TypeError("Response was not JSON");
        }
        const json = await res.json();
        if (json.success && json.data?.homePages?.length > 0) {
          setHomeData(json.data.homePages[0]);
        }
      } catch (err) {
        console.warn("Failed to fetch homepage dynamic data (using static fallback):", err.message || err);
      }
    };
    fetchHomeData();
  }, []);

  const displayFaqData = (homeData?.faqSection?.faqs && homeData.faqSection.faqs.length > 0)
    ? homeData.faqSection.faqs
    : faqData;

  return (
    <>
      <div>
        <div className="container py-5">
          {/* <!-- Header --> */}
          <div className="contact-header fade-in-top">
            <h1 style={{ color: "white" }}>{`Let's Work Together`}</h1>
            <p style={{ color: "white", marginTop: "15px", fontSize: "1.1rem" }}>
              Get in touch with us today. Contact our expert team and let's build something great together.
            </p>
          </div>

          <div className="container address-content">
            {/* <!-- Contact Info --> */}
            <div className="row  ">
              <div
                className="col-md-12 col-lg-4 mb-1"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <div className="content-box ">
                  <h3>Phone No:</h3>

                  <h6>
                    {" "}
                    <p className="call-text">
                      <a href="tel:+91-8949687368 " rel="nofollow">
                        +91-8949687368{" "}
                      </a>
                    </p>
                  </h6>
                </div>
              </div>
              <div
                className="col-md-12 col-lg-4  mb-1"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="content-box  ">
                  <h3>Address:</h3>
                  <h6>
                    301, 3rd Floor, 244-245, Dhruv Marg, Tilak Nagar, Near
                    Baskin-Robins, Gurunanakpura, Raja Park, Jaipur, Rajasthan
                    302004
                  </h6>
                </div>
              </div>
              <div
                className="col-md-12 col-lg-4 mb-1"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <div className="content-box  ">
                  <h3>Email:</h3>
                  <h6>
                    sales@codeqlik.com
                    <br />
                    hr@codeqlik.com
                  </h6>
                </div>
              </div>
            </div>

            <div className="row ">
              <div
                className="col-lg-8 col-md-12 mb-1"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <div className="content-box ">
                  <h3>Opening Hours: </h3>
                  <h6>Mon to Fri: 9.00am - 8.30pm</h6>
                  <h6>Sat: 10.00am - 6.30pm</h6>
                  <h6>Sun: Closed</h6>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-12 mb-1"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="content-box  ">
                  <h3>Follow Us:</h3>
                  <div className="social-icons d-flex  gap-3">
                    <a href="#" className="text-white" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="https://x.com/Rashidrash_1" className="text-white" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-x-twitter"></i>
                    </a>
                    <a href="https://in.linkedin.com/company/codeqlik" className="text-white" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                    <a href="https://www.instagram.com/codeqlik/" className="text-white" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-instagram"></i>
                    </a>
                    <a href="https://youtube.com/@codeqlik?si=dv6QjYWAoocopL_y" className="text-white" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-youtube"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* <!-- Map --> */}
            <div className="map mb-4">
              <h3 className="text-white">Find Us Here</h3>
              <iframe
                src="https://maps.google.com/maps?q=CodeQlik%20-%20IT%20Solutions,%20301,%203rd%20Floor,%20244-245,%20Dhruv%20Marg,%20Tilak%20Nagar,%20near%20Baskin-Robins,%20Gurunanakpura,%20Raja%20Park,%20Jaipur,%20Rajasthan%20302004&t=&z=15&ie=UTF8&iwloc=&output=embed"
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>

        {/* FAQ section */}
        <section className="accordion-bg">
          <div className="accordion-section" data-aos="fade-up">
            <h2 style={{ textTransform: "none", whiteSpace: "pre-line" }}>
              {homeData?.faqSection?.title ? (
                homeData.faqSection.title.includes("\n") 
                  ? homeData.faqSection.title 
                  : homeData.faqSection.title.replace("We've Got Answers!", "\nWe've Got Answers!")
              ) : (
                <>Got Questions <br /> {`We've Got Answers!`}</>
              )}
            </h2>
          </div>
          {displayFaqData.map((item, index) => (
            <div
              key={index}
              className={`accordion ${activeIndex === index ? "active" : ""}`}
            >
              <div
                className="accordion-header"
                onClick={() => toggleAccordion(index)}
              >
                <h3>{item.question}</h3>
                <div className="caret-box">
                  <FaChevronDown
                    className={`caret ${activeIndex === index ? "rotate" : ""}`}
                  />
                </div>
              </div>
              <div className="accordion-content">
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </section>
      </div>
    </>
  );
};

export default ContactClient;
